<template>
  <div>
    <div v-if="!loading && dataSet">
      <div v-if="dataSet.length">
        <v-row no-gutters>
          <v-col cols="12" v-for="(item, i) in dataSet" :key="i">
            <div class="py-2">
              <v-card elevation="1" class="rounded-lg">
                <v-expansion-panels flat>
                  <v-expansion-panel>
                    <v-expansion-panel-header disable-icon-rotate class="pa-0">
                      <v-row no-gutters>
                        <v-col cols="12">
                          <div class="d-flex align-center pa-2">
                            <router-link
                              class="opener_name"
                              :to="`/scholar/${item.user_id}`"
                            >
                              <v-avatar size="50" class="mr-2">
                                <img
                                  :src="
                                    item.profile_picture
                                      ? item.profile_picture
                                      : ava
                                  "
                                  class="obj_fit"
                                  alt="isyan"
                                />
                              </v-avatar>
                            </router-link>
                            <div>
                              <router-link
                                class="opener_name"
                                :to="`/scholar/${item.user_id}`"
                              >
                                <h3 v-snip="1" class="color_default">
                                  {{ item.name }}
                                </h3>
                              </router-link>
                              <p class="ma-0 default_txt">
                                {{ item.no_tf }}
                              </p>
                              <!-- <p class="ma-0 default_txt">
                          {{ $date(item.updated_at).format("DD MMMM, HH:MM") }}
                        </p> -->
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                      <template v-slot:actions>
                        <div
                          class="pa-2 d-flex justify-center align-center flex-column"
                        >
                          <v-btn
                            v-if="item.attend == 'present'"
                            fab
                            color="green"
                            class="mr-2"
                            depressed
                            small
                          >
                            <v-icon color="white"> mdi-account-check</v-icon>
                          </v-btn>
                          <v-btn
                            v-if="item.attend == 'alpha'"
                            fab
                            color="red"
                            class="mr-2"
                            depressed
                            small
                          >
                            <v-icon color="white"> mdi-account-remove</v-icon>
                          </v-btn>
                          <v-btn
                            v-if="item.attend == 'permit'"
                            fab
                            color="orange"
                            class="mr-2"
                            depressed
                            small
                          >
                            <v-icon color="white">
                              mdi-account-injury-outline</v-icon
                            >
                          </v-btn>
                          <p class="ma-0 default_txt">{{ item.attend }}</p>
                        </div>
                      </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <div class="d-flex">
                        <v-card
                          class="runded_lg pa-3 mr-3"
                          dark
                          flat
                          :color="
                            item.attend == 'present'
                              ? 'green'
                              : item.attend == 'permit'
                              ? 'orange'
                              : 'red'
                          "
                        >
                          <v-icon>{{
                            item.attend == "present"
                              ? `mdi-account-check`
                              : item.attend == "permit"
                              ? "mdi-account-injury-outline"
                              : "mdi-account-remove"
                          }}</v-icon>
                        </v-card>
                        <div>
                          <h3>{{ item.attend }}</h3>
                          <p class="default_txt">
                            at
                            {{
                              $date(item.updated_at).format("DD/MM/YYYY HH:MM")
                            }}
                          </p>
                        </div>
                      </div>
                      <p class="default_txt mt-3">Notes</p>
                      <v-card flat class="rounded-lg pa-3" color="#f6f6f6">
                        {{ item.notes }}
                      </v-card>
                      <div class="d-flex justify-end mt-3">
                        <v-btn
                          @click="updateAttendance(item)"
                          color="var(--g)"
                          class="text-capitalize"
                          dark
                          small
                          ><v-icon small class="mr-2">mdi-pencil</v-icon> Update</v-btn
                        >
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card>
            </div>
          </v-col>
        </v-row>
      </div>
      <div
        v-if="!dataSet.length"
        class="d-flex align-center justify-center flex-column"
      >
        <img
          src="../../../../assets/img/gundam/noAttandence.png"
          height="200px"
          alt=""
        />
        <b class="default_txt my-3">No one is absent yet</b>
      </div>
    </div>

    <div v-if="loading">
      <v-row no-gutters>
        <v-col cols="12" v-for="i in 3" :key="i">
          <div class="py-3">
            <v-skeleton-loader
              type="image"
              class="rounded_max"
              height="80px"
            ></v-skeleton-loader>
          </div>
        </v-col>
      </v-row>
    </div>
    <div class="py-2">
      <updat-attendance
        :u_attendance="u_attendance"
        :pocket="pocket"
        @close="u_attendance = false"
        @fetch="fetchData"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import updatAttendance from "../../../../components/course/module/updatAttendance.vue";
export default {
  components: { updatAttendance },
  name: "listAttandace",
  props: ["dataId", "readonly"],
  computed: {
    ...mapState({
      ava: (state) => state.ava,
    }),
  },
  data() {
    return {
      dataSet: null,
      loading: false,
      u_attendance: false,
      pocket: null,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `manage/attendance/${this.dataId}`,
      };
      this.$store
        .dispatch("course/getData", data)
        .then((data) => {
          this.loading = false;
          this.dataSet = data.data;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },

    updateAttendance(item) {
      this.pocket = {
        selected: item.attend,
        notes: item.notes,
        scholar_id: item.id,
        course_attendance_id: this.$route.params.idInstance,
        name: item.name,
      };
      this.u_attendance = true;
    },
  },
};
</script>

<style scoped>
.view_note {
  color: blue;
  cursor: pointer;
}
</style>
